/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { dashboardServices } from "../../../../service/dashboard";
import translationData from '../../../../locales/dashboardTranslation.json'
import { KpiCardNew, SectionHeaderNew } from "./KpiCardNew";
import { LuActivity, LuAlertTriangle, LuCheckCircle, LuClock, LuLayers, LuRotateCcw } from "react-icons/lu";


interface AutoclaveDetailsLayoutProps {
  heading: string;
  selectedDate: any;
}

const columnStyle = {
  margin: "0 0 6px 0",
  // borderBottom: '0.5px solid rgba(0, 0, 0, 0.11)'
};

const lastColumnStyle = {
  margin: "0",
};

const AutoclaveDetailsLayout: React.FC<AutoclaveDetailsLayoutProps> = ({
  heading,
  selectedDate,
}) => {

  interface ColumnData {
    id: number;
    apiName: string;
    displayName: string;
    count: number;
  }
  const [columnsData, setColumnsData] = useState<ColumnData[]>([]);
  const navigate = useNavigate();

  //inner page table link
  const navigateToOtherPage = () => {
    navigate('/autoclave-table'); 
  };

  const switchToPage = (id: number) => {
    if(id == 1){
      navigate(`/autoclave-table`);
    }else if (id >= 3 && id <= 4) {
      navigate(`/inner-view-autoclave/${id}`);
    }
  }
  //api call for autoclave table listing
  const getAutoclaveStatus = async () => {
    try {
      const response = await dashboardServices.getAutoclaveStatus(selectedDate);
      if (response.status && response.statusCode === 200) {
        try {
          const responseData = response.data;
          if (responseData) {
            setColumnsData(prevColumnsData => {
              return prevColumnsData.map(column => {
                const { apiName, displayName } = column;

                const apiCount = responseData[apiName];

                if (apiCount !== undefined) {
                  return { ...column, count: apiCount };
                } else {
                  console.warn(`API response for ${displayName} is undefined or missing.`);
                  return column;
                }
              });
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('user response', error);
    }
  };

  const cardConfig : any = {
    1: { color: "blue", icon: LuLayers },
    2: { color: "slate", icon: LuActivity },
    3: { color: "purple", icon: LuRotateCcw },
    4: { color: "emerald", icon: LuCheckCircle },
    5: { color: "rose", icon: LuClock, statusColor: "text-rose-600" },
    6: { color: "orange", icon: LuAlertTriangle },
  };

  useEffect(() => {
    const AutoclaveDataHead = translationData.AutoclaveDataHead;
    setColumnsData(AutoclaveDataHead.map((item => ({ ...item, count: 0 }))));
    }, []); 

  useEffect(() => {
    getAutoclaveStatus();
  }, [])

  return (
    // <div className="container">
    //   <h2 className="head-style" title="Click here to View AutoClave Details" onClick={navigateToOtherPage}>
    //     {heading}
    //   </h2>
    //   <div className="columns" style={{ padding: "10px" }}>
    //       {columnsData.map((column) => (
    //       <div key={column.id} className="column" style={column.id === columnsData.length ? lastColumnStyle : columnStyle}>
    //       <div className="linkStyle" onClick={() => switchToPage(column.id)}>
    //       <span className= 'column-style'>
    //         {column.displayName}
    //       </span>
    //       <span className="countStyle">{column.count}</span>
    //       </div>
    //       </div>
    //       ))}
    //   </div>
    // </div>

    <div className="lg:col-span-4 flex flex-col">
      <div
        title="Click here to View AutoClave Details"
        onClick={navigateToOtherPage}
        className="cursor-pointer"
      >
        <SectionHeaderNew title={heading} />
      </div>

      <div className="grid grid-cols-2 gap-3 flex-1">
        {columnsData.map((column) => {
          const config = cardConfig[column.id] || {
            color: "slate",
            icon: LuActivity,
          };

          return (
            <div
              key={column.id}
              onClick={() => switchToPage(column.id)}
              className="cursor-pointer"
            >
              <KpiCardNew
                label={column.displayName}
                val={column.count}
                color={config.color}
                icon={config.icon}
                layout="mini"
                statusColor={config.statusColor}
              />
            </div>
          );
        })}
      </div>
    </div>

  );
};

export default AutoclaveDetailsLayout;